import React, { useState, useEffect } from 'react';
import './PhotoGallery.css';
import { useLanguage } from '../context/LanguageContext';

function PhotoGallery() {
  const { t } = useLanguage();
  const [messages, setMessages] = useState([]);
  const [formData, setFormData] = useState({ name: '', message: '' });
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const API_URL = "https://esponjoboda.com";

  // removed unused states isSubmitting and submitMessage (they caused CI eslint errors)

  useEffect(() => {
    fetchMessages();
  }, []);

  const openLightbox = (src) => {
    setSelectedPhoto(src);
  };

  const closeLightbox = () => {
    setSelectedPhoto(null);
  };

  const fetchMessages = async () => {
    try {
      const response = await fetch(`${API_URL}/api/messages`);
      if (response.ok) {
        const data = await response.json();
        setMessages(data.messages || []); // Worker returns { ok: true, messages: [] }
      } else if (response.status === 401) {
        console.log('Messages are protected (admin only).');
      }
    } catch (error) {
      console.error('Error fetching messages:', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmitMessage = async (e) => {
    e.preventDefault();
    console.log('Submitting message:', formData);

    try {
      const response = await fetch(`${API_URL}/api/message`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          code: 'PUBLIC',
          name: formData.name,
          message: formData.message,
          timestamp: new Date().toISOString(),
        }),
      });

      if (response.ok) {
        const result = await response.json();
        console.log('Success result:', result);

        setMessages([...messages, {
          name: formData.name,
          message: formData.message,
          timestamp: new Date().toISOString()
        }]);
        setFormData({ name: '', message: '' });
        alert('¡Mensaje enviado con éxito!');
      } else {
        const errorData = await response.json().catch(() => ({}));
        console.error('Error response:', errorData);
        alert('Error al enviar el mensaje. Intenta de nuevo.');
      }
    } catch (error) {
      console.error('Fetch error:', error);
      alert('Error al enviar el mensaje. Intenta de nuevo.');
    }
  };

  return (
    <div className='photo-gallery'>
      <h2>{t.photogallery_title}</h2>
      <div className='photo-gallery__container'>

        {/* Photos Section */}
        <div className='photo-gallery__wrapper'>
          <div className='photo-gallery__photos'>
            <div className='photo-gallery__photos-grid'>
              <div className='photo-gallery__photo-item'>
                <img
                  className='photo-gallery__photo'
                  src='images/std_caminando.png'
                  alt='Momento especial 1'
                  onClick={() => openLightbox('images/std_caminando.png')}
                />
              </div>
              <div className='photo-gallery__photo-item'>
                <img
                  className='photo-gallery__photo'
                  src='images/window.jpg'
                  alt='Momento especial 2'
                  onClick={() => openLightbox('images/window.jpg')}
                />
              </div>
              <div className='photo-gallery__photo-item'>
                <img
                  className='photo-gallery__photo'
                  src='images/Monet.jpg'
                  alt='Momento especial 3'
                  onClick={() => openLightbox('images/Monet.jpg')}
                />
              </div>
              <div className='photo-gallery__photo-item'>
                <img
                  className='photo-gallery__photo'
                  src='images/sitted.jpg'
                  alt='Momento especial 4'
                  onClick={() => openLightbox('images/sitted.jpg')}
                />
              </div>
              <div className='photo-gallery__photo-item'>
                <img
                  className='photo-gallery__photo'
                  src='images/looking.jpg'
                  alt='Momento especial 4'
                  onClick={() => openLightbox('images/looking.jpg')}
                />
              </div>
              <div className='photo-gallery__photo-item'>
                <img
                  className='photo-gallery__photo'
                  src='images/grooms.jpg'
                  alt='Momento especial 4'
                  onClick={() => openLightbox('images/grooms.jpg')}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Form Section */}
        <div className="message-section">
          <h3>{t.photogallery_book}</h3>
          <form onSubmit={handleSubmitMessage}>
            <div>
              <input
                type="text"
                name="name"
                placeholder={t.photogallery_name}
                value={formData.name}
                onChange={handleInputChange}
                required
              />
            </div>
            <div>
              <textarea
                name="message"
                placeholder={t.photogallery_message}
                value={formData.message}
                onChange={handleInputChange}
                rows="4"
                required
              />
            </div>
            <button
              type="submit"
              disabled={!formData.name.trim() || !formData.message.trim()}
            >
              {t.photogallery_send}
            </button>
          </form>
        </div>
      </div>

      {/* Lightbox Overlay */}
      {
        selectedPhoto && (
          <div className="lightbox-overlay" onClick={closeLightbox}>
            <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
              <button className="lightbox-close" onClick={closeLightbox}>&times;</button>
              <img src={selectedPhoto} alt="Maximized view" className="lightbox-image" />
            </div>
          </div>
        )
      }
    </div >
  );
}
export default PhotoGallery;